import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { membershipPlans, planPath } from "@/lib/plans";

export function HomePlanSummary() {
  return (
    <section
      id="membership-plans"
      className="home-wrap home-membership"
      aria-labelledby="membership-title"
    >
      <div className="home-membership-heading">
        <div>
          <p className="home-eyebrow">MEMBERSHIP THAT FITS YOU</p>
          <h2 id="membership-title">Start Free. Grow your way.</h2>
        </div>
        <Link to="/plans" className="home-membership-review">
          Review plans <ArrowRight size={17} aria-hidden="true" />
        </Link>
      </div>
      <div className="home-membership-grid" aria-label="Plan overview">
        {membershipPlans.map((plan) => (
          <Link
            key={plan.id}
            to={planPath(plan.id)}
            className="home-membership-plan"
            data-plan-summary={plan.id}
          >
            <span className="home-membership-status">
              {plan.available ? "Available now" : "Coming soon"}
            </span>
            <h3>{plan.name}</h3>
            <p>{plan.summary}</p>
            <span className="home-membership-price">
              {plan.available ? plan.price : "Pricing to be announced"}
              {plan.id === "collector_pro" && <small> / month</small>}
            </span>
            {plan.id === "collector_pro" && (
              <small className="home-membership-annual">
                {plan.cadence.replace("/ month or ", "or ")}
              </small>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}
